import { RunbooksDashboardPage } from 'main/components/dashboards/runbooks-dashboard-page'

export const RunbooksDashboard = () => {
  return <RunbooksDashboardPage />
}
